import Profile from "pages/dashboard/profile/Profile"

const EmployeeProfile: React.FC<{}> = () => {
  return (
    <div>
      <Profile isAdmin={false} />
    </div>
  )
}

export default EmployeeProfile
